export default __webpack_public_path__ + "static/1-37910dd90e413d0edc075e3b8609f314.jpg";